import React, { useEffect, useState } from "react";
import store from "../../../../Store";
import { InitialAssemblyState, InitialShadeState, updateAssemblies } from "../../../../Store/entities/assemblies";
import { useAssembliesByQuoteId } from "../../../../Store/entities/assemblies/hooks";
import EditPSOutdoorShadeModalBase from "./EditPSOutdoorShadeBase";

const MassEditPSOutdoor = ({ quoteId, isOpen, onClose }) => {
	const [initAssyState, setInitAssyState] = useState({
		...InitialAssemblyState(),
		unlocked: true,
		shades: [InitialShadeState()]
	});
	const [workingAssembly, setWorkingAssembly] = useState(initAssyState);
	const allSelectedAssemblies = useAssembliesByQuoteId(quoteId).filter((assy) => assy.selected);
	const selectedAssemblies = allSelectedAssemblies.filter((assy) => assy.shade_type_id === 3);
	useEffect(() => {
		if (selectedAssemblies.length > 0) {
			const sharedAssembly = {
				...InitialAssemblyState(),
				unlocked: true,
				shades: [InitialShadeState()]
			};
			Object.keys(sharedAssembly).forEach((key) => {
				if (key !== 'shades' && selectedAssemblies[0]) {
					const firstValue = selectedAssemblies[0][key];
					const isShared = selectedAssemblies.every((assy) => assy[key] === firstValue);
					if (isShared) {
						sharedAssembly[key] = firstValue;
					}
				}
			});

			if (
				selectedAssemblies[0]
				&& selectedAssemblies[0].shades
					&& selectedAssemblies[0].shades[0]
						&& sharedAssembly.shades[0]
			) {
				Object.keys(sharedAssembly.shades[0]).forEach((shadeKey) => {
					const firstValue = selectedAssemblies[0]?.shades?.[0]?.[shadeKey];
					const isShared = selectedAssemblies.every((assy) =>
						assy.shades && assy.shades[0] && assy.shades[0][shadeKey] === firstValue);
					if (isShared && sharedAssembly.shades[0]) {
						sharedAssembly.shades[0][shadeKey] = firstValue;
					}
				});
			}

			setInitAssyState(sharedAssembly);
			setWorkingAssembly(sharedAssembly);
		}
	}, [selectedAssemblies]);

	const setAssembly = (assy) => {
		let currentAssemblies = [...selectedAssemblies];
		Object.entries(workingAssembly).forEach(([key, value]) => {
			if (key === "shades") {
				Object.entries(value[0]).forEach(([shadeKey, shadeVal]) => {
					if (shadeVal !== assy.shades[0][shadeKey]) {
						currentAssemblies = currentAssemblies.map((selectedAssy) => (
							{
								...selectedAssy, shades: selectedAssy.shades.map((selectedShade) => (
									{ ...selectedShade, [shadeKey]: assy.shades[0][shadeKey] }
								))
							}
						));
					}
				});
			}
			if (assy[key] !== value && key !== 'shades') {
				currentAssemblies = currentAssemblies.map((selectedAssy) => ({ ...selectedAssy, [key]: assy[key] }));
			}
		});

		return (JSON.stringify(assy) !== JSON.stringify(workingAssembly))
		&& store.dispatch(updateAssemblies({ quoteId, assemblies: currentAssemblies }));
	};

	return <EditPSOutdoorShadeModalBase
		isOpen={isOpen}
		onClose={onClose}
		quoteId={quoteId}
		assembly={workingAssembly}
		setAssembly={setAssembly}
		massEdit={selectedAssemblies.length > 1}
	/>;
};

export default MassEditPSOutdoor;
